module.exports = __webpack_public_path__ + "img/billiard.e99947a6.jpg";